import gstStateCodes from "../data/gstStateCodes.json";

export const getStateCode = (state) => {
  return gstStateCodes[state] || null;
};
